import React from 'react';
import { Helmet } from 'react-helmet';
import MarketingHeader from '../../components/ui/MarketingHeader';
import RegistrationHeader from './components/RegistrationHeader';
import RegistrationForm from './components/RegistrationForm';
import SocialAuthOptions from './components/SocialAuthOptions';
import LoginPrompt from './components/LoginPrompt';

const UserRegistration = () => {
  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>Create Account - BPMLflows | SAP Implementation Platform</title>
        <meta 
          name="description" 
          content="Join BPMLflows to streamline your SAP implementation workflow. Create your account and start managing requirements, fit/gap analysis, and digital approvals." 
        />
        <meta name="keywords" content="SAP registration, account creation, implementation platform, BPMLflows signup" />
      </Helmet>

      <MarketingHeader />

      <main className="pt-16">
        <div className="min-h-screen flex items-center justify-center px-4 sm:px-6 lg:px-8 py-12">
          <div className="w-full max-w-md space-y-8">
            {/* Registration Header */}
            <RegistrationHeader />

            {/* Registration Card */}
            <div className="bg-card border border-border rounded-lg shadow-elevation-2 p-6 sm:p-8">
              <div className="space-y-6">
                {/* Social Authentication Options */}
                <SocialAuthOptions />

                {/* Registration Form */}
                <RegistrationForm />
              </div>
            </div>

            {/* Login Prompt */}
            <LoginPrompt />
          </div>
        </div>
      </main>

      {/* Background Pattern */}
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-32 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute -bottom-40 -left-32 w-96 h-96 bg-accent/5 rounded-full blur-3xl" />
      </div>
    </div>
  );
};

export default UserRegistration;